import { Typography } from '@scale/scaleui';
import { useState } from 'react';

interface CommentCardProps {
  comment: string;
  createdAt: Date;
  createdBy: string;
  onRemove: () => void;
}

export const CommentCard: React.FC<CommentCardProps> = ({
  comment,
  createdAt,
  createdBy,
  onRemove,
}: CommentCardProps) => {
  const [isRemoving, setIsRemoving] = useState<boolean>(false);
  return (
    <div
      className="bg-neutral-0 border border-neutral-100 shadow-sm rounded-md p-4"
      style={{ opacity: isRemoving ? 0.2 : 1 }}
    >
      <div className="flex flex-col gap-2">
        <Typography.Subtitle4>
          {createdBy} at{' '}
          {createdAt.toLocaleDateString('en-US', { month: 'numeric', day: 'numeric' })}
        </Typography.Subtitle4>
        <div>{comment}</div>
        <div
          onClick={() => {
            setIsRemoving(true);
            onRemove();
          }}
        >
          <Typography.Subtitle4 className="cursor-pointer text-primary-500">
            Remove Comment
          </Typography.Subtitle4>
        </div>
      </div>
    </div>
  );
};
